import React from 'react';
import moment from 'moment';
import { Button } from 'antd';
import { comma } from 'utils/comma';

export const columns = [
  {
    Header: '정책명',
    accessor: 'name',
    width: 60
  },
  {
    Header: '상태',
    accessor: 'isactive',
    width: 5,
    Cell: ({
      row: {
        original: { isactive }
      }
    }) => <div>{isactive ? '활성' : '비활성'}</div>
  },
  {
    Header: '종류',
    accessor: 'type',
    width: 5,
    Cell: ({
      row: {
        original: { type }
      }
    }) => <div>{DateType[type]}</div>
  },
  {
    Header: '지급 복지포인트',
    accessor: 'amount',
    width: 60,
    type: 'number',
    Cell: ({
      row: {
        original: { amount }
      }
    }) => <div>{comma(amount)}</div>
  },
  {
    Header: '세부정보',
    accessor: 'detail',
    Cell: ({ row: { original } }) => <Detail {...original} />
  }
];

export const welfareHistoryColumns = [
  {
    Header: '#',
    accessor: 'idx',
    width: 10
  },
  {
    Header: '날짜',
    accessor: 'regdate',
    width: 100,
    Cell: ({
      row: {
        original: { regdate }
      }
    }) => <div>{moment(regdate).format('YYYY-MM-DD HH:mm')}</div>
  },
  {
    Header: '복지그룹',
    accessor: 'groupname',
    width: 80
  },
  {
    Header: '복지정책',
    accessor: 'policyname'
  },
  {
    Header: '상세내역',
    accessor: 'log',
    Cell: ({
      row: {
        original: { log }
      }
    }) => <div>{log[0].content}</div>
  },
  {
    Header: '변경한 사람',
    accessor: 'username'
  }
];

const DateType = {
  DAY: '일일',
  LONGTERM: '장기',
  INFINITE: '무제한',
  DEMAND: '신청'
};

const Detail = (original) => {
  const { idx, deposit, onClick } = original;
  return (
    <div>
      {deposit}
      <Button key={idx} onClick={() => onClick(original)} style={{ float: 'right', marginRight: 10.5 }}>
        변경
      </Button>
    </div>
  );
};
